<h2  *ngIf="isVersion2()  && dataCessacao >= dataLimiteCessacao" class="mt-5">{{cardConfiguration.title}}</h2>


<fieldset *ngIf="isVersion2() && dataCessacao >= dataLimiteCessacao" [disabled]="isWorkflowOnSubscriber">
  <div class="row">
    <div *ngIf="checkVisibilityBaseRevenue()" class="col-sm-4">
      <div class="form-group">
        <label for="BaseRevenue">
          <span class="mandatory">*</span>{{'CardRemunerationsLastUntilCutoff.BaseRevenue' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardRemunerationsLastUntilCutoff.BaseRevenue' | translate}}"></span>
        </label>
        <div class="position-relative">
          <input class="form-control input-left" type="text" currency
                 placeholder="{{'Placeholders.Generic.Currency' | translate}}"
                 [(ngModel)]="cardData.baseRevenue" name="baseRevenueCutoff" #baseRevenueCutoff="ngModel" required maxValue="999000" messageFieldType="currency">
          <span class="input-icon-span-left">€</span>
          <validation-message [control]="baseRevenueCutoff"></validation-message>
        </div>
      </div>
    </div>
    <div *ngIf="checkVisibilityLegalBase()" class="col-sm-8">
      <div class="form-group">
        <label for="LegalBase">
          {{'CardRemunerationsLastUntilCutoff.LegalBase' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardRemunerationsLastUntilCutoff.LegalBase' | translate}}"></span>
        </label>

        <input class="form-control" type="text" maxlength="60"
               placeholder="{{'Placeholders.CardRemunerationsLastUntilCutoff.LegalBase' | translate}}"
               [(ngModel)]="cardData.legalBase" name="legalBase" #legalBase="ngModel">
        <validation-message [control]="legalBase"></validation-message>
      </div>
    </div>
  </div>

  <div class="row">
    <!--Ínicio Categoria-->
    <div *ngIf="(!checkIfMagDipMil() || checkCGDStarterEntity()) && checkVisibilityCategory()" class="col-sm-4">
      <div class="form-group">
        <label for="Category"><span class="mandatory">*</span>Categoria</label>
        <input class="form-control" type="text"
               required
               placeholder="Indique a categoria"
               [(ngModel)]="cardData.category" name="category" #category="ngModel" maxlength="50">
        <validation-message [control]="category"></validation-message>
      </div>
    </div>

    <div *ngIf="(checkIfMagDipMil() && !checkCGDStarterEntity()) && checkVisibilityCategory()" class="col-sm-4">
      <div class="form-group">
        <label for="Category">
          <span class="mandatory">*</span>
          Categoria
        </label>
        <select class="custom-select" [(ngModel)]="cardData.category" name="category"
                #category="ngModel"
                required
                (ngModelChange)="changedCategory($event)"
                [clearRelated]="{model : this.cardData , propsToReset : ['taxIndex', 'taxStep']}"
                [dropdownTitle]="{value : cardData.category }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of categories" [value]="domain.description">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="category"></validation-message>
      </div>
    </div>
    <!--Fim Categoria-->
    <!--Início Nível-->
    <div *ngIf="checkVisibilityTaxLevel()" class="col-sm-4">
      <div class="form-group">
        <label for="TaxLevel">
          <span *ngIf="checkCGDStarterEntity()" class="mandatory">*</span>
          Nível
        </label>
        <select class="custom-select" [(ngModel)]="cardData.taxLevel" name="taxLevel"
                #taxLevel="ngModel"
                (ngModelChange)="changedTaxLevels($event)"
                [required]="checkCGDStarterEntity()"
                [clearRelated]="{model : this.cardData , propsToReset : ['taxStep']}"
                [dropdownTitle]="{value : cardData.taxLevel }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of getTaxLevels()" [value]="domain.value">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="taxLevel"></validation-message>
      </div>
    </div>
    <!--Fim Nível-->
    <!--Início Escalão-->
     <div *ngIf="(professionalClass !== '5' && professionalClass !== '4' && professionalClass !== '17' && !checkCGDStarterEntity()) && checkVisibilityTaxStep()" class="col-sm-4">
      <div class="form-group">
        <label for="TaxStep">{{'CardRemunerationsLastUntilCutoff.TaxStep' | translate}}</label>
        <input class="form-control" type="text"
               placeholder="{{'Placeholders.CardRemunerationsLastUntilCutoff.TaxStep' | translate}}"
               [(ngModel)]="cardData.taxStep" name="taxStep" #taxStep="ngModel" maxlength="40">
        <validation-message [control]="taxStep"></validation-message>
      </div>
    </div>

    <div *ngIf="(professionalClass === '5' || professionalClass === '4' || professionalClass === '17' || checkCGDStarterEntity()) && checkVisibilityTaxStep()" class="col-sm-4">
      <div class="form-group">
        <label for="TaxStep" [class.disabled]="cardData.category === undefined">
          <span *ngIf="checkMandatoryTaxStep()" class="mandatory">*</span>
          {{'CardRemunerationsLastUntilCutoff.TaxStep' | translate}}
        </label>
        <select class="custom-select" [(ngModel)]="cardData.taxStep" name="taxStep"
                #taxStep="ngModel"
                (ngModelChange)="changedTaxSteps($event)"
                [dropdownTitle]="{value : cardData.taxStep }" nullableSelect
                [disabled]="cardData.category === undefined"
                [required]="checkMandatoryTaxStep()">
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of taxSteps" [value]="domain.value">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="taxStep"></validation-message>
      </div>
    </div>
    <!--Fim Escalão-->
    <!--Início Indíce-->
    <div *ngIf="checkVisibilityTaxIndex()" class="col-sm-4">
      <div *ngIf="professionalClass !== '5' && professionalClass !== '4' && professionalClass !== '17'" class="form-group">
        <label for="TaxIndex">{{'CardRemunerationsLastUntilCutoff.TaxIndex' | translate}}</label>
        <input class="form-control" type="text" maxlength="40"
               placeholder="{{'Placeholders.CardRemunerationsLastUntilCutoff.TaxIndex' | translate}}"
               [(ngModel)]="cardData.taxIndex" name="taxIndex" #taxIndex="ngModel">
        <validation-message [control]="taxIndex"></validation-message>
      </div>

      <div *ngIf="professionalClass === '5' || professionalClass === '4' || professionalClass === '17'" class="form-group">
        <label for="TaxIndex" [class.disabled]="cardData.taxStep === undefined">
          <span *ngIf="checkMandatoryTaxIndex()" class="mandatory">*</span>
          {{'CardRemunerationsLastUntilCutoff.TaxIndex' | translate}}
        </label>
        <select class="custom-select" [(ngModel)]="cardData.taxIndex" name="taxIndex"
                #taxIndex="ngModel"
                [dropdownTitle]="{value : cardData.taxIndex }"
                nullableSelect
                [disabled]="cardData.taxStep === undefined"
                [required]="checkMandatoryTaxIndex()">
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of taxIndexes" [value]="domain.description">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="taxIndex"></validation-message>
      </div>
    </div>
    <!--Fim Indíce-->
  </div>

  <div class="row d-flex align-items-center">
    <div class="col-sm-8">
      <h3 class="mb-0">
        {{'CardRemunerationsLastUntilCutoff.OtherRemunerations' | translate}}
      </h3>
    </div>
    <div class="col-sm-4 text-end">
      <button (click)="expandNewEntry=!expandNewEntry"
              [ngClass]="!expandNewEntry ? '' : 'disabled'"
              aria-label="Nova entrada" type="button" class="btn btn-link disable-on-fieldset">
        <span class="icon-add"></span> <span>{{'CardRemunerationsLastUntilCutoff.RemunerationsOtherTable.AddItem' | translate}}</span>
      </button>
    </div>
  </div>

  <!--New table entry inputs-->
  <div *ngIf="expandNewEntry" class="shadow ml-5 mr-5 p-4 mb-4 mt-5">
    <button type="button" class="close" aria-label="Fechar" (click)="expandNewEntry=!expandNewEntry">
      <span aria-hidden="true" class="icon-close text-primary"></span>
    </button>
    <h3 class="text-primary">{{'CardRemunerationsLastUntilCutoff.RemunerationsOtherTable.AddItem' | translate}}</h3>
    <remuneration-other-table-edit [itemList]="cardData.remunerationsList" (listChanged)="onRemunerationsListChanged($event)"></remuneration-other-table-edit>
  </div>
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">{{'CardRemunerationsLastUntilCutoff.RemunerationsOtherTable.Designation' | translate}}</th>
        <th scope="col">{{'CardRemunerationsLastUntilCutoff.RemunerationsOtherTable.Start' | translate}}</th>
        <th scope="col">{{'CardRemunerationsLastUntilCutoff.RemunerationsOtherTable.Value' | translate}}</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let tableItem of cardData.remunerationsList; let i = index">
        <tr  [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
          <td class=" align-items-center">
            <i rowExternalValidation="remunerationsList" [tableIndex]="i"></i>
            {{tableItem.suplementDescription}}
          </td>
          <td class="fitwidth">{{tableItem.startDate | date : 'yyyy-MM-dd'}}</td>
          <td *ngIf="tableItem.renumerationType !== 'B'">{{tableItem.remunerationValue  | commaToPoint | currency:'EUR':'symbol':undefined:'pt-PT'}}</td>
          <td *ngIf="tableItem.renumerationType === 'B'">(...)</td>
          <td class="buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
            <button type="button" class="btn-icon" aria-label="Editar" [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic">
              <span class="p-1" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : disableTableRemoveIcons ? 'text-primary icon-more' : 'text-primary icon-edit'"></span>
            </button>
            <button *ngIf="!disableTableRemoveIcons" type="button" class="btn-icon" aria-label="Apagar" (click)="removeFromList(cardData.remunerationsList ,i,$event)">
              <span class="icon-trash p-1" [ngClass]="expandedRowIndex == i ? 'text-primary' : 'text-primary'"></span>
            </button>
          </td>
        </tr>
        <tr *ngIf="expandedRowIndex == i" [collapse]="expandedRowIndex != i" [isAnimated]="false">
          <td class="p-0" colspan="4" id="collapseBasic">
            <div class="ml-5 mr-5 p-4">
              <remuneration-other-table-edit [itemList]="cardData.remunerationsList" [editIndex]="i" (listChanged)="onRemunerationsListChanged($event)"></remuneration-other-table-edit>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</fieldset>

<fieldset *ngIf="!isVersion2()" [disabled]="isWorkflowOnSubscriber">
  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="BaseRevenue">
          <span class="mandatory">*</span>{{'CardRemunerationsLastUntilCutoff.BaseRevenue' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardRemunerationsLastUntilCutoff.BaseRevenue' | translate}}"></span>
        </label>
        <div class="position-relative">
          <input class="form-control input-left" type="text" currency
                 placeholder="{{'Placeholders.Generic.Currency' | translate}}"
                 [(ngModel)]="cardData.baseRevenue" name="baseRevenueCutoff" #baseRevenueCutoff="ngModel" required maxValue="999000" messageFieldType="currency">
          <span class="input-icon-span-left">€</span>
          <validation-message [control]="baseRevenueCutoff"></validation-message>
        </div>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="TaxStep">{{'CardRemunerationsLastUntilCutoff.TaxStep' | translate}}</label>
        <input class="form-control" type="text"
               placeholder="{{'Placeholders.CardRemunerationsLastUntilCutoff.TaxStep' | translate}}"
               [(ngModel)]="cardData.taxStep" name="taxStep" #taxStep="ngModel" maxlength="10">
        <validation-message [control]="taxStep"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="TaxIndex">{{'CardRemunerationsLastUntilCutoff.TaxIndex' | translate}}</label>
        <input class="form-control" type="text" numeric="4"
               placeholder="{{'Placeholders.CardRemunerationsLastUntilCutoff.TaxIndex' | translate}}"
               [(ngModel)]="cardData.taxIndex" name="taxIndex" #taxIndex="ngModel">
        <validation-message [control]="taxIndex"></validation-message>
      </div>
    </div>

  </div>
  <div class="row">
    <div class="col-sm-8">
      <div class="form-group">
        <label for="LegalBase">
          {{'CardRemunerationsLastUntilCutoff.LegalBase' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardRemunerationsLastUntilCutoff.LegalBase' | translate}}"></span>
        </label>

        <input class="form-control" type="text" maxlength="60"
               placeholder="{{'Placeholders.CardRemunerationsLastUntilCutoff.LegalBase' | translate}}"
               [(ngModel)]="cardData.legalBase" name="legalBase" #legalBase="ngModel">
        <validation-message [control]="legalBase"></validation-message>
      </div>
    </div>
  </div>

  <div class="row d-flex align-items-center">
    <div class="col-sm-8">
      <h3 class="mb-0">
        {{'CardRemunerationsLastUntilCutoff.OtherRemunerations' | translate}}
      </h3>
    </div>
    <div class="col-sm-4 text-end">
      <button (click)="expandNewEntry=!expandNewEntry"
              [ngClass]="!expandNewEntry ? '' : 'disabled'"
              aria-label="Nova entrada" type="button" class="btn btn-link disable-on-fieldset">
        <span class="icon-add"></span> <span>{{'CardRemunerationsLastUntilCutoff.RemunerationsOtherTable.AddItem' | translate}}</span>
      </button>
    </div>
  </div>

  <!--New table entry inputs-->
  <div *ngIf="expandNewEntry" class="shadow ml-5 mr-5 p-4 mb-4 mt-5">
    <button type="button" class="close" aria-label="Fechar" (click)="expandNewEntry=!expandNewEntry">
      <span aria-hidden="true" class="icon-close text-primary"></span>
    </button>
    <h3 class="text-primary">{{'CardRemunerationsLastUntilCutoff.RemunerationsOtherTable.AddItem' | translate}}</h3>
    <remuneration-other-table-edit [itemList]="cardData.remunerationsList" (listChanged)="onRemunerationsListChanged($event)"></remuneration-other-table-edit>
  </div>
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">Designação de Remuneração</th>
        <th scope="col">{{'CardRemunerationsLastUntilCutoff.RemunerationsOtherTable.Start' | translate}}</th>
        <th scope="col">{{'CardRemunerationsLastUntilCutoff.RemunerationsOtherTable.Value' | translate}}</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let tableItem of cardData.remunerationsList; let i = index">
        <tr  [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
          <td class="align-items-center">
            <i rowExternalValidation="remunerationsList" [tableIndex]="i"></i>
            {{tableItem.designation}}
          </td>
          <td class="fitwidth">{{tableItem.startDate | date : 'yyyy-MM-dd'}}</td>
          <td>{{currencyFormat(tableItem.remunerationValue)}} €</td>
          <td class="buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
            <button type="button" class="btn-icon" aria-label="Editar" [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic">
              <span class="p-1" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : disableTableRemoveIcons ? 'text-primary icon-more' : 'text-primary icon-edit'"></span>
            </button>
            <button *ngIf="!disableTableRemoveIcons" type="button" class="btn-icon" aria-label="Apagar" (click)="removeFromList(cardData.remunerationsList ,i,$event)">
              <span class="icon-trash p-1" [ngClass]="expandedRowIndex == i ? 'text-primary' : 'text-primary'"></span>
            </button>
          </td>
        </tr>
        <tr *ngIf="expandedRowIndex == i" [collapse]="expandedRowIndex != i" [isAnimated]="false">
          <td class="p-0" colspan="4" id="collapseBasic">
            <div class="ml-5 mr-5 p-4">
              <remuneration-other-table-edit [itemList]="cardData.remunerationsList" [editIndex]="i" (listChanged)="onRemunerationsListChanged($event)"></remuneration-other-table-edit>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</fieldset>
<!--<pre>{{cardData | json}}</pre>-->
